// 사용자가 의도적으로 설정한 값
export const ULK_PREFERENCE_THEME = 'preferenceTheme';

// 사용자별 UI 상태 기억용
export const ULK_UI_STATUS_STUDENT_DRAWER_OPEN = 'uiStatusStudentDrawerOpen';
export const ULK_UI_STATUS_TEACHER_DRAWER_OPEN = 'uiStatusTeacherDrawerOpen';
export const ULK_UI_STATUS_CLS_DRAWER_OPEN = 'uiStatusClsDrawerOpen';
export const ULK_UI_STATUS_LESSON_REPORT_WRITE_VIEW = 'uiStatusLessonReportWriteView';
export const ULK_UI_STATUS_BILL_GROUP_LIST_VIEW = 'uiStatusBillGroupListView';

// 사용자별 마지막 사용값 기억용
export const ULK_LAST_ATT_SHOULD_SEND_NOTIFICATION = 'lastAttShouldSendNotification';
export const ULK_LAST_BILL_RECEIPT_ITEM_KIND_LIST = 'lastBillReceiptItemKindList';
export const ULK_LAST_POST_IS_STUDENT_READABLE = 'lastPostIsStudentReadable';
